export default __webpack_public_path__ + "static/media/2022_April_Wald.8d800b96.webp";